import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { showConfirmAlert } from "../../../components/components-react/ReactAlert";
import { add_cto_head, update_cto_head } from "../../../data/ApiEndpoints";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import SelectDropdown from "../../../components/components-react/SelectDropdown";
import { fetchCtoCategoriesData } from "../../../redux/reducers/apiSlice";

const validateForm = (formValues) => {
  const errors = {};

  if (!formValues.selCategoryName) {
    errors.selCategoryName = "Category is required";
  }

  if (!formValues.headName) {
    errors.headName = "Head name is required";
  }

  return errors;
};

const CTOHeadForm = ({
  userInfoData,
  isEdit,
  rowData,
  cancelUpdate,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { ctoCategories } = useSelector((state) => state.api);

  const [allCtoCategories, setAllCtoCategories] = useState([]);
  const iniFormValues = {
    headName: "",
    selCategoryName: "",
    isActive: false,
    isFixed: false,
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;

    setFormValues((prevs) => ({
      ...prevs,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onChangeDropdown = (name, value) => {
    setIsSubmit(false);
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormErrors(validateForm(formValues));
    setIsSubmit(true);
  };

  const handleAdd = async (payload) => {
    setIsSubmit(false);

    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? update_cto_head : add_cto_head;
    const token = userInfoData?.token;

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        setFormValues(iniFormValues);
        cancelUpdate();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  function getCTOCategories(filters = {}) {
    dispatch(
      fetchCtoCategoriesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getCTOCategories();
  }, []);

  useEffect(() => {
    if (ctoCategories?.status && ctoCategories?.data) {
      const allCategories = ctoCategories.data?.map((item) => ({
        value: item.uid,
        label: item.category_name,
        info: item,
      }));

      setAllCtoCategories(allCategories || []);
    } else {
      setAllCtoCategories([]);
    }
  }, [ctoCategories]);

  useEffect(() => {
    if (isEdit && rowData) {
      setFormValues((prevs) => ({
        ...prevs,
        headName: rowData?.head_name || "",
        selCategoryName:
          rowData?.category_id && rowData?.category_name
            ? {
                value: rowData?.category_id,
                label: rowData?.category_name,
              }
            : "",
        isActive: rowData?.status === "active" ? true : false,
      }));
    } else {
      setFormValues(iniFormValues);
    }
  }, [isEdit, rowData]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const requestBody = {
        head_name: formValues.headName || "",
        category_id: formValues.selCategoryName?.value || "",
        status: formValues.isActive ? "active" : "inactive",
      };

      if (isEdit && rowData?.uid) {
        requestBody.uid = rowData?.uid;
      }

      const handleConfirm = async () => {
        handleAdd(requestBody);
      };

      showConfirmAlert(handleConfirm, `Are you sure!`, "Edit", "Submit");
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="add-cto-container cto-head">
      <form className="formContainer mt-0">
        <div className="formInputsGrid flexSystem">
          <div className="formInputBox">
            <div
              className={`commonWrapper ${
                formErrors.selCategoryName ? "formError" : ""
              } `}>
              <SelectDropdown
                options={allCtoCategories}
                selectedOption={formValues.selCategoryName}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selCategoryName", selectedValue)
                }
                name="CTO Category"
              />
            </div>
          </div>

          <div className="formInputBox">
            <input
              type="text"
              placeholder="Enter CTO Head Name"
              className={`formInput ${formErrors?.headName ? "formError" : ""}`}
              name="headName"
              value={formValues.headName}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox checkbox-wrapper">
            <div
              className="flex-box"
              style={{ width: "auto", flexDirection: "row" }}>
              <label className="checkboxLabel">
                <input
                  type="checkbox"
                  name="isActive"
                  checked={formValues.isActive}
                  onChange={onChangeInput}
                />
                {formValues.isActive ? "Active" : "Inactive"}
              </label>

              <label className="checkboxLabel">
                <input
                  type="checkbox"
                  name="isFixed"
                  checked={formValues.isFixed}
                  onChange={onChangeInput}
                />
                {formValues.isFixed ? "Fixed" : "Not Fixed"}
              </label>
            </div>
          </div>

          {/* <div className="formInputBox formInputSwitchBox">
            <Form.Check
              type="checkbox"
              name="isActive"
              className={`${formErrors?.isActive ? "formError" : ""}`}
              label={`${formValues.isActive ? "Active" : "Inactive"}`}
              checked={formValues.isActive}
              onChange={onChangeInput}
            />
          </div> */}
        </div>
      </form>

      <div className="formButtons">
        <Button
          type="button"
          className="saveBtn"
          variant="dark"
          onClick={handleSubmit}>
          {isEdit ? "Update CTO Head" : "Add New CTO Head"}
        </Button>
        {isEdit && (
          <button
            type="button"
            className="cencelBtn"
            onClick={(e) => {
              e.preventDefault();
              cancelUpdate();
            }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-x"
              viewBox="0 0 16 16">
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default CTOHeadForm;
